if (!customElements.get('free-shipping')) {
  class FreeShipping extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      let amount_text = this.querySelector('.free-shipping--text span');
      let total = parseInt(this.dataset.cartTotal, 10);
      let currency = this.dataset.currency || (Shopify.currency && Shopify.currency.active) || '';


      console.log('Currency:', currency); // ✅ Debug log

      let minimum;
      if (currency.toUpperCase() === 'USD') {
        minimum = 0; // $50.00 in cents
        console.log('Using $50 USD free shipping threshold');
      } else {
        minimum = Math.round(parseInt(this.dataset.minimum, 10));
        console.log('Using theme setting:', minimum);
      }

      let percentage = 1;
      this.remainingText = this.querySelector('.free-shipping--text-remaining');
      this.fullText = this.querySelector('.free-shipping--text-full');

      if (total < minimum) {
        percentage = total / minimum;

        if (amount_text) {
          let remaining = minimum - total;
          remaining = Math.round(remaining);
          let format = "${{amount}}";
          amount_text.innerHTML = formatMoney(remaining, format);
        }

        this.remainingText.style.display = 'block';
        this.fullText.style.display = 'none';
      } else {
        this.remainingText.style.display = 'none';
        this.fullText.style.display = 'block';
      }

      this.style.setProperty('--percentage', percentage);
    }
  }

  customElements.define('free-shipping', FreeShipping);
}
